import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import $ from 'jquery'

import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class DefaultBuildingField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dropdownOpen: false,
    }
    this.clickHandler = this.clickHandler.bind(this)
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.selectOption = this.selectOption.bind(this)
  }

  componentDidMount() {
    $(document.body).on('click', this.clickHandler)
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || ''
    this.props.setFormFieldValue(formType, fieldName, initialValue)
    this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
  }

  componentWillUnmount() {
    $(document.body).off('click', this.clickHandler)
  }

  componentWillReceiveProps(nextProps) {
    const { formType, fieldName, defaultValue } = this.props
    if (defaultValue !== nextProps.defaultValue) {
      this.props.setFormFieldValue(formType, fieldName, nextProps.defaultValue)
      this.props.validateFormField(formType, fieldName, this.isValid(nextProps.defaultValue))
    }
  }

  clickHandler(e) {
    if ($(e.target).closest('.field-default-building .control').length === 0) {
      this.setState({ dropdownOpen: false })
    }
  }

  toggleDropdown(e) {
    e.preventDefault()
    const { isDisabled } = this.props
    if (isDisabled) {
      return false
    }
    this.setState({ dropdownOpen: !this.state.dropdownOpen })
  }

  selectOption(e, value) {
    e.preventDefault()
    const { formType, fieldName } = this.props
    this.props.setFormFieldValue(formType, fieldName, value)
    this.props.validateFormField(formType, fieldName, this.isValid(value))
    this.setState({ dropdownOpen: false })
  }

  isValid(val) {
    return val && val.toString().length > 0
  }

  render() {
    const { form, formType, fieldName, label, options, placeholder, additionalClass, isDisabled } =
      this.props
    const currentValue = form[formType][fieldName].value
    const selectedOption = options.find((item) => item.value === currentValue)

    return (
      <div
        className={`field field-select field-default-building ${
          this.state.dropdownOpen ? 'is-open' : ''
        } ${additionalClass || ''} ${isDisabled ? 'field--disabled' : ''}`}
      >
        {label && <label className="label">{label}</label>}
        <div className="control">
          <div className="select">
            <div className="field-select__input input" onClick={this.toggleDropdown}>
              <span>{selectedOption ? selectedOption.label : placeholder || 'Select ...'}</span>
            </div>
            <div className="field-select__dropdown">
              {options?.length > 0 &&
                options.map((option, index) => (
                  <span
                    key={`${option.value}-${index}`}
                    data-value={option.value}
                    onClick={(e) => this.selectOption(e, option.value)}
                  >
                    {option.label}
                  </span>
                ))}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

DefaultBuildingField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  additionalClass: PropTypes.string,
  isDisabled: PropTypes.bool,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(DefaultBuildingField)
